import useRootData from '~/hooks/useRootData';

export const useCategories = () => {
  const rootData = useRootData();
  return rootData?.categories;
};
